import Page from 'components/common/Page'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import { HeroBlock } from './components/HeroBlock'
import { BlockContainer } from 'components/common/BlockContainer'
import colors from 'utility/colors'
import { WhyPartnerBlock } from './components/WhyPartnerBlock'
import { WhoPartnerBlock } from './components/WhoPartnerBlock'
import { WhatYouGainBlock } from './components/WhatYouGainBlock'
import { GettingStartedBlock } from './components/GettingStartedBlock'
import { BecomePartnerBlock } from './components/BecomePartnerBlock'

export const PartnerHomePage = () => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<Page
			title={`Helping homeowners pay fair property taxes in Texas - ${tenantName}`}
			description={`Welcome to ${tenantName} - let us help you get and pay fair property taxes in Texas!`}
			footer
		>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
				<BlockContainer
					style={{
						background: `linear-gradient(${colors.WHITE}, ${secondaryColor}1A)`,
					}}
				>
					<HeroBlock />
				</BlockContainer>
				<BlockContainer>
					<WhyPartnerBlock />
				</BlockContainer>
				<BlockContainer backgroundColor={`#96A8B51A`}>
					<WhoPartnerBlock />
				</BlockContainer>
				<BlockContainer>
					<WhatYouGainBlock />
				</BlockContainer>
				<BlockContainer backgroundColor={`#96A8B51A`}>
					<GettingStartedBlock />
				</BlockContainer>
				<BlockContainer>
					<BecomePartnerBlock />
				</BlockContainer>
			</div>
		</Page>
	)
}
